module.exports = __webpack_public_path__ + "6ec5433bc911860b7fb3c54021c14a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114x0069.jpg
// module id = 377
// module chunks = 0